package core.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 06.04.23
 * Author : mariorosshirt
 */
@Serializable
enum class EJSBridgeActions {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    @SerialName("show_video")
    SHOW_VIDEO,

    @SerialName("export_wishlist")
    EXPORT_WISHLIST,

    @SerialName("export_productlist")
    EXPORT_PRODUCTLIST,

    @SerialName("share_wishlist")
    SHARE_WISHLIST,

    @SerialName("share_productlist")
    SHARE_PRODUCTLIST,

    @SerialName("external_link")
    EXTERNAL_LINK,

    @SerialName("show_colourwall")
    SHOW_COLOURWALL,

    @SerialName("share_native")
    SHARE_NATIVE,

    @SerialName("activate_tracking")
    ACTIVATE_TRACKING,

    @SerialName("deactivate_tracking")
    DEACTIVATE_TRACKING
    
    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}